module.exports = __webpack_public_path__ + "static/media/user.65035ed9.svg";